var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images"},[_c('ul',_vm._l((10),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.showDefectImage(item)}}},[_c('img',{attrs:{"src":_vm.demoImage,"alt":""}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }